var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup228(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_228",
    "data-name": "Group 228",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35.971,
    height: 35.948,
    viewBox: "0 0 35.971 35.948",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_186",
    "data-name": "Rectangle 186",
    width: 35.971,
    height: 35.948,
    fill: "#d10a11"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_227",
    "data-name": "Group 227",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3748",
    "data-name": "Path 3748",
    d: "M0,28.765v-.5q0-12.67,0-25.34A2.666,2.666,0,0,1,2.072.087,3.391,3.391,0,0,1,2.865.018C10.539.015,18.213.035,25.886,0A2.843,2.843,0,0,1,28.8,2.944c-.042,5.242-.016,10.484-.016,15.727a2.731,2.731,0,0,1-2.949,2.938c-5.271,0-10.541,0-15.811.012a1.433,1.433,0,0,0-.8.265Q4.743,25.214.285,28.573c-.065.049-.134.091-.285.192",
    transform: "translate(0 -0.001)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3749",
    "data-name": "Path 3749",
    d: "M127.881,142.413h.587c5.736,0,11.473-.021,17.209.011a3.618,3.618,0,0,0,3.587-2.462,5.381,5.381,0,0,0,.2-1.449c.017-3.3.009-6.608.009-9.912v-.494a2.766,2.766,0,0,1,3.577,2.6q-.012,11.114,0,22.228c0,.055-.011.111-.023.233-.275-.2-.521-.373-.761-.553q-4.264-3.2-8.533-6.391a1.163,1.163,0,0,0-.651-.2c-4.063-.012-8.127-.049-12.189.012A2.814,2.814,0,0,1,127.879,143c.013-.178,0-.357,0-.583",
    transform: "translate(-117.083 -117.226)",
    fill: "#d10a11"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup228);
export default __webpack_public_path__ + "static/media/Group 228.b001d346b74398e05373c4b5807ff4f6.svg";
export { ForwardRef as ReactComponent };